import React, { useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import BuySellFunction from "../components/Games/BuySellFunction";

const ChartSearchPage = () => {

  const [stocksData, setStockData] = useState([]);
  const { term } = useParams();
  const [sidebarToggle] = useOutletContext();
  const [loadings, setLoadings] = useState(false);
  return (
    <>
      <DashboardHeader
        toggle={sidebarToggle}
        searchVal={term}
        setStocksData={setStockData}
        setLoader={setLoadings}
      />
      <PageHeaderTitle title={"Create Order"} />
      <BuySellFunction game_id={null} slug={null} />
    </>
  );

};

export default ChartSearchPage;
